export const promoBanners = {
  promoBannerAlt: "Banner promocional",
  promoBannerSlide: "Diapositiva",
  tagDrop: "Drop",
  tagTorneo: "Torneo",
  tagRace: "Race",
  tagNuevo: "Nuevo",
  tagPromo: "Promo",
};
